import { render, staticRenderFns } from "./IconArrowEndRectangle.vue?vue&type=template&id=64ee248e"
import script from "./IconArrowEndRectangle.vue?vue&type=script&lang=js"
export * from "./IconArrowEndRectangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports